import { all, takeEvery } from 'redux-saga/effects'
import { AUTH_LOGIN_SUCCESS } from '../authentication/constants'
import doFetchRegistrations from './flows/fetch-registrations-flow'

export function* watchRegistration() {
  yield all([takeEvery(AUTH_LOGIN_SUCCESS, doFetchRegistrations)])
}
